var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    fill: "#c9a236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 253.547c43.83 0 79.488-35.659 79.488-79.488S299.83 94.57 256 94.57s-79.488 35.659-79.488 79.488S212.17 253.547 256 253.547zm0-119.724c22.185 0 40.235 18.05 40.235 40.235s-18.05 40.235-40.235 40.235-40.235-18.05-40.235-40.235 18.05-40.235 40.235-40.235z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.544 336.96h-81.23c47.418-57.196 71.458-108.77 71.458-153.424v-9.469c0-93.616-76.159-169.78-169.772-169.78S86.228 80.45 86.228 174.068v9.469c0 44.654 24.04 96.227 71.458 153.424h-81.23L0 507.713h512L435.544 336.96zM125.483 183.537v-9.469h-.001c0-71.973 58.551-130.528 130.518-130.528s130.518 58.555 130.518 130.528v9.469c0 36.873-24.171 84.32-69.9 137.211-23.255 26.898-46.783 48.948-60.622 61.268-13.743-12.227-37.043-34.061-60.234-60.828-45.977-53.069-70.279-100.668-70.279-137.651zm-23.595 192.677h91.225c27.26 27.921 49.292 45.947 50.496 46.928L256 433.228l12.39-10.086c1.205-.981 23.236-19.008 50.496-46.928h91.225l41.305 92.246H60.584l41.304-92.246z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.5f969ce9dbd0852c6744cfc40c4df9e4.svg";
export { ForwardRef as ReactComponent };